import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useTrackEventMutation } from 'src/common/slices';
import { useActiveCampaign } from 'src/features/campaigns/hooks/use-active-campaign';

export const SubscribeNowLabel = {
  FlashSaleTopBar: 'flash-sale-top-bar',
  FlashSaleModal: 'flash-sale-modal',
  Hack2WinFlashSaleBanner: 'hack2win-flash-sale-banner',
  Hack2WinPromoBanner: 'hack2win-promo-banner',
  Hack2WinTicketLink: 'hack2win-ticket-link',
  Hack2WinFlashSaleTicketBanner: 'hack2win-flash-sale-ticket-banner',
  PathsPageBottomBanner: 'paths-page-bottom-banner',
  ComparePlansTable: 'compare-plans-table',
  PlanCardMonthly: 'plan-card-monthly',
  PlanCardYearly: 'plan-card-yearly',
} as const;

export const useTrackSubscribeNow = () => {
  const { pathname } = useLocation();
  const [trackEvent] = useTrackEventMutation();
  const { campaign } = useActiveCampaign();

  const handler = useCallback(
    async (clickedOn: (typeof SubscribeNowLabel)[keyof typeof SubscribeNowLabel]) =>
      trackEvent({
        event: 'click-subscribe-now',
        properties: {
          'clicked-on': clickedOn,
          campaign: campaign?.name,
          path: pathname,
        },
      }),
    [trackEvent, pathname, campaign?.name],
  );

  return handler;
};
